import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { FilePdfOutlined, PictureOutlined } from '@ant-design/icons';
import { apiUrls } from '../apiUrls.js';

const PublicImage = ({ type, url }) => {

  // useEffect(() => {
  //   if (mediaId != null)
  //     getData()
  //   else
  //     setBase64String('')
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [mediaId])

  //image
  if (type == 1)
    return <a rel='noreferrer' target='_blank' href={url}><img className='margintop-7' style={{ height: 200, width: 200 }} src={url}></img></a>

  //video
  else if (type == 2)
    return <a rel="noreferrer" target="_blank" href={url}>
      <video
        className="margintop-7"
        style={{ height: 200, width: 200 }}
        src={url}
        controls
      />
    </a>

  //pdf
  else if (type == 4)
    return <a rel="noreferrer" target="_blank" href={url}>
      <audio
        className="margintop-7"
        style={{ width: 200 }}
        src={url}
        controls
      />
    </a>


  return <a rel='noreferrer' target='_blank' href={url}><img className='margintop-7' style={{ height: 200, width: 200 }} src={url}></img></a>
};


PublicImage.propTypes = {
  type: PropTypes.number,
  url: PropTypes.string
};

export default PublicImage;
